import { useState } from "react";
import { host } from '../constants';

export const useFranchises = () => {
    return useProvideFranchises();
};

function useProvideFranchises() {
    const [franchises, setFranchises] = useState(null);
    const [count, setCount] = useState(0);
    const [franchise, setFranchise] = useState(null);

    const loadAll = async (token, take, skip, filter) => {
        setFranchises(null);
        const franchises = await loadAllByHttp(token, take, skip, filter);
        setFranchises(franchises);
        return franchises;
    };

    const loadCount = async (token, filter) => {
        const loaded = await loadCountByHttp(token, filter);
        setCount(loaded);
        return loaded;
    };

    const getById = async (token, franchiseId) => {
        const loaded = await loadByIdByHttp(token, franchiseId);
        setFranchise(loaded);
        return loaded;
    };

    const create = async (token, franchise) => {
        const created = await createByHttp(token, franchise);
        return created;
    };

    const update = async (token, franchise) => {
        const updated = await updateByHttp(token, franchise);
        return updated;
    };

    const deleteFranchise = async (token, franchise) => {
        const deleted = await deleteByHttp(token, franchise);
        return deleted;
    };

    const getBySerialId = async (token, serialId) => {
        const response = await fetch(`${host}/api/Franchise/by-serial/${serialId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) return null;
        return await response.json();
    };

    const addSerial = async (token, franchiseId, serialId, orderIndex) => {
        const response = await fetch(`${host}/api/Franchise/${franchiseId}/serials/${serialId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(orderIndex)
        });
        return response.ok;
    };

    const removeSerial = async (token, franchiseId, serialId) => {
        const response = await fetch(`${host}/api/Franchise/${franchiseId}/serials/${serialId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.ok;
    };

    const getSerials = async (token, franchiseId) => {
        const response = await fetch(`${host}/api/Franchise/${franchiseId}/serials`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    };

    return {
        franchises,
        count,
        franchise,
        loadCount,
        loadAll,
        getById,
        create,
        update,
        deleteFranchise,
        getBySerialId,
        addSerial,
        removeSerial,
        getSerials
    };
}

// API Helpers
async function loadAllByHttp(token, take, skip, filter) {
    const filterParam = filter ? `&filter=${encodeURIComponent(filter)}` : '';
    const url = `${host}/api/franchise?take=${take}&skip=${skip}${filterParam}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    const data = await response.json();
    console.log('Franchises loaded', data);
    return data;
}

async function loadCountByHttp(token, filter) {
    const filterParam = filter ? `?filter=${encodeURIComponent(filter)}` : '';
    const url = `${host}/api/franchise/count${filterParam}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    const data = await response.json();
    console.log('Franchise count loaded', data);
    return data;
}

async function loadByIdByHttp(token, franchiseId) {
    const url = `${host}/api/franchise/${franchiseId}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    const data = await response.json();
    console.log('Franchise loaded by ID', data);
    return data;
}

async function createByHttp(token, franchise) {
    const url = `${host}/api/franchise`;

    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(franchise),
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("ДЕТАЛІ ПОМИЛКИ ВІД СЕРВЕРА:", errorText);
        throw new Error("Сервер повернув помилку. Деталі в консолі.");
    }

    const data = await response.json();
    console.log('Franchise created', data);
    return data;
}

async function updateByHttp(token, franchise) {
    const url = `${host}/api/franchise`;

    const response = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(franchise),
    });

    const data = await response.json();
    console.log('Franchise updated', data);
    return data;
}

async function deleteByHttp(token, franchise) {
    const url = `${host}/api/franchise`;

    const response = await fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(franchise),
    });

    const data = await response.json();
    console.log('Franchise deleted', data);
    return data;
}